/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import currency from "currency.js";
import {
  calculateAttendance,
  calculateInvexRetainment,
  calculateWorkDays,
  fetchActionsUtil,
  useCookie,
  stringifyQueryString,
  calculateTaxWithTotal,
} from "../../utils";
import { URLS } from "../urls";
import { toast } from "react-toastify";
import moment from "moment";
import {
  totalUniqueNum,
  checkDateYear,
  calculateMultiPayRollSettings,
  getGrossPayments,
  calculateLoan,
  converArrayToObject,
} from "../../utils";
import { toNumber } from "lodash";

export const useComputePayroll = ({
  payrollDate = {
    payrollMonth: "",
    payrollYear: new Date().getFullYear(),
  },
  queryParams = {},
  theQueryParams = {},
  useExcel = "",
  theexcelData = [],
  fullAndFinally = "",
}) => {
  const branch_id = useCookie("branch_id");

  const [normalEmployees, setNormalEmployees] = useState([]);
  const [deductionSettings, setDeductionSettings] = useState([]);
  const [bonusSettings, setBonusSettings] = useState([]);
  const [allownaceSettings, setAllowanceSettings] = useState([]);
  const [benefitSettings, setBenefitSettings] = useState([]);
  const [leaveSetup, setLeaveSetup] = useState({});
  const [pendingRetirement, setPendingRetirement] = useState([]);
  const [totalGross, setTotalGross] = useState(0);
  const [totalNet, setTotalNet] = useState(0);
  const [totalDeduct, setTotalDeduct] = useState(0);
  const [totalbonus, setTotalbonus] = useState(0);
  const [totalallowance, setTotalallowance] = useState(0);
  const [totalbenefit, setTotalbenefit] = useState(0);
  const [returnParams, setReturnParams] = useState({});
  const [theLocations, settheLocations] = useState([]);
  const [theContracts, settheContracts] = useState([]);
  const [loanSettings, setloanSettings] = useState([]);
  const [companySettings, setcompanySettings] = useState({});
  const [IsRuning, setIsRuning] = useState(false);
  const [IsFetching, setsFetching] = useState(true);
  const [customHeaders, setCustomHeaders] = useState([]);
  const [settingHeaders, setSettingsHeaders] = useState({});
  const [attendanceSetting, setAttendanceSetting] = useState({});
  const [AllowanceGroupName, setAllowanceGroupName] = useState([]);
  const [BenefitGroupName, setBenefitGroupName] = useState([]);
  const [BonusGroupName, setBonusGroupName] = useState([]);
  const [DeductionGroupName, setDeductionGroupName] = useState([]);
  const [payrollSetting, setPayrollSetting] = useState([]);
  const [terminations, setTerminations] = useState([]);
  const [resignations, setResignations] = useState([]);
  const [suspensions, setSuspensions] = useState([]);
  const [searchItems, setSearchItems] = useState([]);
  const [payrollCycle, setPayrollCycle] = useState({
    payrollStartDate: new Date(),
    payrollEndDate: new Date(),
  });

  const token = "dummy token";

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      if (IsRuning) {
        getEmployees();
      }
    }
    return () => {
      isMounted = false;
    };
  }, [useExcel, theexcelData, IsRuning, payrollDate, queryParams]);

  useEffect(() => {
    // Set Total Gross, Net and deductions
    setTotalGross(() =>
      normalEmployees?.reduce((p, c) => currency(p).add(c.ogGrossPay), 0)
    );
    setTotalNet(() =>
      normalEmployees?.reduce((p, c) => currency(p).add(c.netPay), 0)
    );
    setTotalDeduct(() =>
      normalEmployees?.reduce((p, c) => currency(p).add(c.totalDeduction), 0)
    );
    setTotalbonus(() =>
      normalEmployees?.reduce((p, c) => currency(p).add(c.totalBonus), 0)
    );
    setTotalallowance(() =>
      normalEmployees?.reduce((p, c) => currency(p).add(c.totalAllowances), 0)
    );
    setTotalbenefit(() =>
      normalEmployees?.reduce((p, c) => currency(p).add(c.totalBenefits), 0)
    );
  }, [normalEmployees]);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      getData();
    }

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchRetirement();
    }

    return () => {
      isMounted = false;
    };
  }, [payrollDate, payrollCycle]);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchPayrollCycle();
    }

    return () => {
      isMounted = false;
    };
  }, [payrollDate]);

  const fetchPayrollCycle = async () => {
    try {
      setIsRuning(false);
      const payrollCycleData = await fetchActionsUtil(
        `${URLS.backendPayroll}/get-payroll-cycle?branch_id=${branch_id}&date=${payrollDate?.payrollYear}-${payrollDate?.payrollMonth}-1`
      );

      setPayrollCycle(payrollCycleData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsRuning(true);
    }
  };

  const fetchRetirement = async () => {
    if (
      process.env.REACT_APP_HAS_INVEX === "true" &&
      payrollDate.payrollMonth
    ) {
      try {
        setsFetching(true);
        const retairement = await fetch(
          `${URLS.mainSiteBackend}/users/salary/pending-retirement?payrollStartDate=${payrollCycle.payrollStartDate}&payrollEndDate=${payrollCycle.payrollEndDate}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Token ${token}`,
            },
          }
        );

        const { retairment } = await retairement.json();
        setPendingRetirement(retairment);
      } catch (error) {
        console.log(error);
      } finally {
        setsFetching(false);
      }
    }
  };

  const getByDate = async () => {
    try {
      const overtimeData = fetchActionsUtil(
        `${URLS.backendOvertime}/get-payroll-overtimes-by-branch?branch_id=${branch_id}&date=${payrollDate?.payrollYear}-${payrollDate?.payrollMonth}-1`
      );

      const leaveData = fetchActionsUtil(
        `${
          URLS.backendApplyLeaves
        }/dynamic-by-months/${branch_id}?payroll=${true}&date=${
          payrollDate?.payrollYear
        }-${payrollDate?.payrollMonth}-1`
      );

      const overtimeExtraData = await fetchActionsUtil(
        `${URLS.backendOvertime}/overtimesExtras?branch_id=${branch_id}&month=${payrollDate.payrollMonth}&year=${payrollDate.payrollYear}`
      );

      const attendanceData = await fetchActionsUtil(
        `${URLS.backendattendance}/get-payroll-attendance-by-branch?branch_id=${branch_id}&date=${payrollDate?.payrollYear}-${payrollDate?.payrollMonth}-1`
      );

      const [
        overtimeResult,
        leaveResult,
        attendanceResult,
        overtimeExtraResult,
      ] = await Promise.all([
        overtimeData,
        leaveData,
        attendanceData,
        overtimeExtraData,
      ]);

      return {
        overtimeExtra: overtimeExtraResult?.overtimes || [],
        leaveSettings: leaveResult?.leave || [],
        overSettings: overtimeResult?.overtimes || [],
        attendance: attendanceResult?.attendance || [],
      };
    } catch (error) {
      console.log(error);
    }
  };

  const getData = async () => {
    try {
      const deductionData = fetchActionsUtil(
        `${URLS.backendDeductionSettings}/enabled?branch_id=${branch_id}`
      );

      const bonusData = fetchActionsUtil(
        `${URLS.backendBonusSettings}/enabled?branch_id=${branch_id}`
      );

      const allowanceData = fetchActionsUtil(
        `${URLS.backendAllowance}/enabled?branch_id=${branch_id}`
      );

      const benefitData = fetchActionsUtil(
        `${URLS.backendBenefit}/enabled?branch_id=${branch_id}`
      );

      const loanData = fetchActionsUtil(
        `${URLS.backendLoan}?branch_id=${branch_id}`
      );

      const locationsData = fetchActionsUtil(
        `${URLS.backendLocations}/get?branch_id=${branch_id}`
      );

      const contractsData = fetchActionsUtil(
        `${URLS.backendContracts}/get?branch_id=${branch_id}`
      );

      const salarySettingsData = fetchActionsUtil(
        `${URLS.backendsalarySetting}/get/${branch_id}`
      );

      const settingsData = fetchActionsUtil(
        `${URLS.backendCompanySettings}/get-settings`,
        "POST"
      );

      const allowanceGroupData = fetchActionsUtil(
        `${URLS.backendAllowance}/all-group?branch_id=${branch_id}`
      );

      const benefitGroupData = fetchActionsUtil(
        `${URLS.backendBenefit}/all-group?branch_id=${branch_id}`
      );

      const bonusGroupData = fetchActionsUtil(
        `${URLS.backendBonusSettings}/all-group?branch_id=${branch_id}`
      );

      const deductionGroupData = fetchActionsUtil(
        `${URLS.backendDeductionSettings}/all-group?branch_id=${branch_id}`
      );

      const payrollSettingData = fetchActionsUtil(
        `${URLS.backendPayroll}/get-settings/${branch_id}`
      );

      const terminationsData = fetchActionsUtil(
        `${URLS.backendTermination}/get-terminations/${branch_id}`
      );
      const resignationData = fetchActionsUtil(
        `${URLS.backendResignation}/get/${branch_id}`
      );

      const suspensionsData = fetchActionsUtil(
        `${URLS.backendSuspension}/get/${branch_id}`
      );

      const attendanceData = fetchActionsUtil(
        `${URLS.backendattendance}/get-settings/${branch_id}`
      );

      const levelSettingData = fetchActionsUtil(
        `${URLS.backendLeaves}/get-settings/${branch_id}`
      );

      const gradesData = fetchActionsUtil(
        `${URLS.backendJobGrades}/get/${branch_id}`,
        "GET",
        token
      );

      const departmentsData = fetchActionsUtil(
        `${URLS.backendDepartments}/get/${branch_id}`,
        "GET",
        token
      );

      const categoryData = fetchActionsUtil(
        `${URLS.backendJobCategory}/get/${branch_id}`,
        "GET",
        token
      );

      const [
        deductionResult,
        bonusResult,
        allowanceResult,
        benefitResult,
        loanResult,
        locationsResult,
        contractsResult,
        settingsResult,
        salarySettingsResult,
        allowanceGroupResult,
        benefitGroupResult,
        bonusGroupResult,
        deductionGroupResult,
        payrollSettingResult,
        terminationsResult,
        suspensionsResult,
        attendanceResult,
        levelSettingResult,
        gradesResult,
        departmentsResult,
        categoryResult,
        resignationResult,
      ] = await Promise.all([
        deductionData,
        bonusData,
        allowanceData,
        benefitData,
        loanData,
        locationsData,
        contractsData,
        settingsData,
        salarySettingsData,
        allowanceGroupData,
        benefitGroupData,
        bonusGroupData,
        deductionGroupData,
        payrollSettingData,
        terminationsData,
        suspensionsData,
        attendanceData,
        levelSettingData,
        gradesData,
        departmentsData,
        categoryData,
        resignationData,
      ]);

      // ---------- Salary Settings  ------------
      const items = {};
      if (
        Object.entries(salarySettingsResult?.jobGrades[0] || {}).length === 0
      ) {
        Object.entries(salarySettingsResult?.jobGrades[0] || {}).forEach(
          (el) => {
            if (el[1] > 0) {
              items[`${el[0]}`] = true;
            }
          }
        );
      }

      const salarySettings = salarySettingsResult?.jobGrades[0]?.custom?.map(
        (el) => el.name
      );
      // ---------- Salary Settings  ------------

      const grades = gradesResult?.jobGrades?.map((el) => ({
        value: el?._id,
        label: el?.name,
      }));
      const department = departmentsResult?.departments?.map((el) => ({
        value: el?._id,
        label: el?.name,
      }));

      const category = categoryResult?.jobCategories?.map((el) => ({
        value: el?._id,
        label: el?.name,
      }));

      setSearchItems({
        grades,
        department,
        category,
      });

      setcompanySettings({
        ...settingsResult?.settings,
      });

      setSuspensions(suspensionsResult?.suspensions);
      setTerminations(terminationsResult?.terminations);
      setPayrollSetting(payrollSettingResult?.settings);
      setResignations(resignationResult.resignations);

      setBenefitGroupName(benefitGroupResult?.allowance);
      setAllowanceGroupName(allowanceGroupResult?.allowance);
      setBonusGroupName(bonusGroupResult?.allowance);
      setDeductionGroupName(deductionGroupResult?.allowance);

      setSettingsHeaders(items);
      setCustomHeaders(salarySettings);

      setAllowanceSettings(allowanceResult?.allowance);
      setBenefitSettings(benefitResult?.benefit);
      setDeductionSettings(deductionResult?.deductionSettings);
      setBonusSettings(bonusResult?.bonusSettings);
      settheLocations(locationsResult?.locations);
      settheContracts(contractsResult?.contracts);
      setloanSettings(loanResult?.loan);

      setAttendanceSetting({
        ...attendanceResult?.attendance,
      });

      setLeaveSetup(levelSettingResult?.leaveSettings);

      setIsRuning(true);
    } catch (error) {
      console.log(error);
    }
  };

  const getEmployees = async () => {
    try {
      // check if its getting from excel or database
      let mainEmployees;
      setsFetching(true);

      if (payrollDate?.payrollMonth) {
        if (useExcel !== "Use Timesheet") {
          let employeesResult = await fetchActionsUtil(
            `${
              URLS.backendPayroll
            }/get-employees/${branch_id}?${stringifyQueryString({
              ...queryParams,
              fullAndFinally,
            })}&date=${payrollDate?.payrollYear}-${payrollDate?.payrollMonth}-1`
          );

          const { employees, count, endIndex, startIndex } = employeesResult;

          mainEmployees = employees;
          setReturnParams({
            count,
            endIndex,
            startIndex,
          });
        } else {
          mainEmployees = theexcelData;
        }

        mainEmployees = await calculateEmployeePayroll(mainEmployees);

        setNormalEmployees(mainEmployees);
      } else {
        setNormalEmployees([]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setsFetching(false);
    }
  };

  const calculateEmployeePayroll = async (mainEmployees) => {
    try {
      const { overtimeExtra, leaveSettings, overSettings, attendance } =
        await getByDate();

      const normalEmployees = mainEmployees?.map((employee) => {
        const custom =
          employee?.jobInfo?.usergrade?.custom?.length > 0
            ? employee?.jobInfo?.usergrade?.custom
            : customHeaders?.map((el) => ({
                name: el,
                value: 0,
              }));

        employee = {
          ...employee?.personalInfo,
          ...employee?.jobInfo,
          ...converArrayToObject(
            employee?.jobInfo?.usergrade?.custom
              ? employee?.jobInfo?.usergrade?.custom
              : [],
            "value",
            "name",
            true
          ),
          custom,
          ...employee?.jobInfo?.usergrade?.salary,
          userId: employee.userId,
          bankDetails: employee.bankDetails ?? {},
          gradeName: employee?.jobInfo?.grade?.name,
          emps_id: employee?._id,
          totalDaysWorked: employee?.totalDaysWorked,
        };

        const StaffTermination = terminations?.find(
          (em) => em?.employeeId === employee?.userId
        );

        const StaffResignation = resignations?.find(
          (em) => em?.employeeId === employee?.userId
        );

        const StaffSuspension = suspensions?.find(
          (em) => em?.employeeId === employee?.userId
        );

        //Calculate The worked Days

        const start = moment(payrollCycle.payrollStartDate);
        const end = moment(payrollCycle.payrollEndDate);

        let current = end.diff(start, "days") + 1; // Adding 1 to include the start date

        if (companySettings?.customWorkingDays) {
          current = companySettings?.workingDays;
        } else {
          companySettings.workingDays = current;
        }

        if (useExcel !== "Use Timesheet") {
          if (employee?.startDate) {
            current = calculateWorkDays({
              date: employee?.startDate,
              payrollDate,
              current,
              payrollCycle,
            });
          }

          if (StaffTermination) {
            current = calculateWorkDays({
              date: StaffTermination?.terminationDate,
              payrollDate,
              current,
              workedDays: true,
              payrollCycle,
            });
          }

          if (StaffResignation) {
            current = calculateWorkDays({
              date: StaffResignation?.resignationDate,
              payrollDate,
              current,
              workedDays: true,
              payrollCycle,
            });
          }

          if (StaffSuspension) {
            if (StaffSuspension.type === "Payment") {
              current = calculateWorkDays({
                date: StaffSuspension?.suspensionDate,
                payrollDate,
                current,
                workedDays: true,
                payrollCycle,
              });
            } else {
              current = 0;
            }
          }

          employee.totalDaysWorked = current;
        }

        if (attendanceSetting.AdjustAbsences) {
          const employeeAttendance = attendance.filter(
            (el) => el?.ID === employee?.employeeId
          );

          if (employeeAttendance.length > 0) {
            let Absent = employeeAttendance.filter(
              (el) => el?.result === "Absent"
            );

            Absent = Absent.length;

            employee.totalDaysWorked = employee.totalDaysWorked - Absent;
            if (employee.totalDaysWorked < 0) {
              employee.totalDaysWorked = 0;
            }
          }
        }

        let userExtras = overtimeExtra?.find(
          (el) => el?.employeeId === employee?.employeeId
        );

        if (!userExtras) {
          userExtras = {
            DaysCommitted: employee.totalDaysWorked,
            DayOn: 0,
            TransitDays: 0,
            OverStayDays: 0,
            ArrearsDays: 0,
            employeeId: employee?.employeeId,
            month: payrollDate.payrollMonth,
            year: payrollDate.payrollYear,
            branch_id,
          };
        } else {
          userExtras = {
            ...userExtras,
            DaysCommitted: employee.totalDaysWorked,
            month: payrollDate.payrollMonth,
            year: payrollDate.payrollYear,
            branch_id,
          };
        }

        employee.usedlocation = theLocations?.find(
          (el) => el._id === employee?.workLocation
        )?.name;

        employee.usedlocation = employee.usedlocation
          ? employee.usedlocation
          : employee?.workLocation?.name;

        employee.usedcontract = theContracts?.find(
          (el) => el._id === employee?.contractType
        )?.contractName;

        const retaire = pendingRetirement?.find(
          (el) => el?.Staff_ID === employee?.employeeId
        );

        const allNums = totalUniqueNum(
          benefitSettings,
          allownaceSettings,
          bonusSettings,
          deductionSettings
        );

        let allPREV = [];
        let benes = [];
        let allow = [];
        let bon = [];
        let deduct = [];

        const data = getGrossPayments({
          employee,
          settings: companySettings,
          useExcel,
        });

        for (const key of allNums) {
          const be = calculateMultiPayRollSettings({
            data: benefitSettings.filter((el) => el.level === key),
            employee,
            pre: allPREV,
            settings: companySettings,
            useExcel,
            totalGross: data?.grossPay,
            payrollDate,
          });

          benes = [...benes, ...be.otherData];
          allPREV = [...allPREV, ...be.otherData];

          const allo = calculateMultiPayRollSettings({
            data: allownaceSettings.filter((el) => el.level === key),
            employee,
            pre: allPREV,
            settings: companySettings,
            useExcel,
            overSettings,
            leaves: leaveSettings,
            totalGross: data?.grossPay,
            payrollDate,
            leaveSettings: leaveSetup,
          });

          allow = [...allow, ...allo.otherData];
          allPREV = [...allPREV, ...allo.otherData];

          const bons = calculateMultiPayRollSettings({
            data: bonusSettings.filter((el) => el.level === key),
            employee,
            pre: allPREV,
            settings: companySettings,
            useExcel,
            totalGross: data?.grossPay,
            payrollDate,
          });

          bon = [...bon, ...bons.otherData];
          allPREV = [...allPREV, ...bons.otherData];

          const dedt = calculateMultiPayRollSettings({
            data: deductionSettings.filter((el) => el.level === key),
            employee,
            pre: allPREV,
            settings: companySettings,
            useExcel,
            totalGross: data?.grossPay,
            payrollDate,
          });

          deduct = [...deduct, ...dedt.otherData];
          allPREV = [...allPREV, ...dedt.otherData];
        }

        const benefits = {
          totalSum: benes.reduce((c, p) => c + p.total, 0),
          otherData: benes,
        };

        const allowances = {
          totalSum: allow.reduce((c, p) => c + p.total, 0),
          otherData: allow,
        };

        const bonus = {
          totalSum: bon.reduce((c, p) => c + p.total, 0),
          otherData: bon,
        };

        let penCom = deduct.find((el) => el.slug === "company-pension");
        let penTotal = deduct.find((el) => el.slug === "pension");

        penCom = penCom ? penCom?.total : 0;
        penTotal = penTotal ? penTotal?.total : 0;
        penTotal = penCom + penTotal;

        const deductions = {
          totalSum: deduct.reduce((c, p) => c + p.total, 0) - penCom,
          otherData: deduct,
        };

        //---------------- Calculate Loan -----------------------------------------------
        const employeeLoan = loanSettings.filter(
          (el) =>
            el?.userID?._id === employee?.emps_id && el?.Term !== undefined
        );

        let empLoan = {};

        const unCompletedLoan = employeeLoan.filter(
          (el) => el?.status !== "Completed"
        );

        if (
          unCompletedLoan[0]?.payments?.length > 0 &&
          unCompletedLoan[0]?.loanmotion !== "Pause" &&
          unCompletedLoan[0]?.Term === "Annual" &&
          checkDateYear(unCompletedLoan[0]?.paidDate)
        ) {
          empLoan = calculateLoan(unCompletedLoan, employee);
        } else if (
          unCompletedLoan[0]?.payments?.length > 0 &&
          unCompletedLoan[0]?.loanmotion !== "Pause" &&
          unCompletedLoan[0]?.Term !== "Annual"
        ) {
          empLoan = calculateLoan(unCompletedLoan, employee);
        }

        //--------------------- Get the deducted loan --------------------------
        const loanDeduct = parseFloat(
          empLoan?.deductAmount ? empLoan?.deductAmount : 0
        );

        //---------------------- Calculate all deductions ------------------------
        let allTotalDeduction =
          parseFloat(deductions.totalSum) + parseFloat(loanDeduct);

        //-------------------------- Calculate all income --------------------------
        const income =
          parseFloat(bonus.totalSum) +
          parseFloat(allowances.totalSum) +
          parseFloat(benefits.totalSum) +
          parseFloat(data.ogGrossPay);

        //------------------------------- Calculate Net pay ------------------------
        let netPay = parseFloat(income) - parseFloat(allTotalDeduction);

        //----------------------------------- Calculate Attendance ---------------------
        const attendanceData = calculateAttendance({
          attendance,
          employee,
          attendanceSetting,
          grossPay: data.ogGrossPay,
          netPay,
        });

        allTotalDeduction =
          parseFloat(allTotalDeduction) + parseFloat(attendanceData.total);

        netPay = parseFloat(netPay) - parseFloat(attendanceData.total);

        // -------------------------------- Calculate Payee Tax Normal -------------------------
        let totalExemption = 0;

        if (payrollSetting?.exemptionDeductions?.length > 0) {
          totalExemption = deductions?.otherData?.filter(({ _id }) =>
            payrollSetting?.exemptionDeductions?.find((ele) => _id === ele)
          );

          totalExemption = totalExemption?.reduce((c, p) => c + p.total, 0);
        }

        let CRAGrossPurpose = data.ogGrossPay;

        // let CRAGrossPurpose =
        //   data.ogGrossPay - toNumber(totalExemption.toFixed(2));

        // CRAGrossPurpose =
        //   CRAGrossPurpose === data.ogGrossPay ? 0 : CRAGrossPurpose;

        const CRAGrossPurposePercentage =
          payrollSetting?.grossForCraPurposePercentage
            ? toNumber(
                (
                  (payrollSetting?.grossForCraPurposePercentage / 100) *
                  CRAGrossPurpose
                ).toFixed(2)
              )
            : 0;

        const personalAllowance = payrollSetting?.personalAllowance
          ? toNumber((payrollSetting?.personalAllowance / 12).toFixed(2))
          : 0;

        const totalRelief = toNumber(
          (CRAGrossPurposePercentage + personalAllowance).toFixed(2)
        );

        let chargeableIncome = toNumber(
          (data.ogGrossPay - totalRelief - totalExemption).toFixed(2)
        );

        chargeableIncome =
          chargeableIncome === data.ogGrossPay ? 0 : chargeableIncome;

        const computation = payrollSetting?.taxRateAsPerMonthlyComputation.sort(
          (a, b) => a.ratePercentage - b.ratePercentage
        );

        const { taxRateArray, taxRateAsPerMonthlyTotal } =
          calculateTaxWithTotal({
            computation,
            chargeableIncome,
          });

        // console.log({
        //   totalExemption,
        //   CRAGrossPurpose,
        //   CRAGrossPurposePercentage,
        //   personalAllowance,
        //   totalRelief,
        //   chargeableIncome,
        //   computation,
        //   taxRateArray,
        //   taxRateAsPerMonthlyTotal,
        // });

        const checkPayeeTax = deductions?.otherData?.filter(
          (ele) => ele.taxLaw === true
        );

        if (checkPayeeTax.length > 0) {
          deductions.otherData = deductions?.otherData?.map((el) => {
            if (el.taxLaw === true) {
              el = { ...el, total: taxRateAsPerMonthlyTotal };
            }
            return el;
          });

          deductions.totalSum =
            parseFloat(deductions.totalSum) +
            parseFloat(taxRateAsPerMonthlyTotal);

          allTotalDeduction =
            parseFloat(allTotalDeduction) +
            parseFloat(taxRateAsPerMonthlyTotal);

          netPay = parseFloat(netPay) - parseFloat(taxRateAsPerMonthlyTotal);
        }

        //-------------------------- Calculate retainment (Always the last )----------------------------
        const { remainingRetairment, retairefee } = calculateInvexRetainment({
          retaire,
          netPay,
        });

        netPay = parseFloat(netPay) - parseFloat(remainingRetairment);

        return {
          ...data.employee,
          totalExemption,
          CRAGrossPurpose,
          CRAGrossPurposePercentage,
          personalAllowance,
          chargeableIncome,
          taxRateArray,
          taxRateAsPerMonthlyTotal,
          totalRelief,
          loanDeduct,
          attendanceDetails: attendanceData.data,
          attendanceTotal: attendanceData.total,
          totalDaysWorked: employee?.totalDaysWorked,
          empLoan,
          ogGrossPay: data.ogGrossPay,
          grossPay: data.grossPay,
          otherDeductions: 0,
          bonuses: 0,
          totalDeduction: deductions.totalSum,
          ogNetPay: netPay,
          netPay,
          deductions: deductions.otherData,
          totalBonus: bonus.totalSum,
          totalAllowances: allowances.totalSum,
          totalBenefits: benefits.totalSum,
          bonus: bonus.otherData,
          allowances: allowances.otherData,
          benefits: benefits.otherData,
          AllowanceGroupName,
          BenefitGroupName,
          BonusGroupName,
          DeductionGroupName,
          debitAccountNo: "--",
          debitBankCode: "--",
          creditAccountNo: employee.bankDetails?.accountNumber,
          creditBankCode: employee.bankDetails?.bankCode,
          allTotalDeduction:
            parseFloat(allTotalDeduction) + parseFloat(retairefee),
          numProration:
            parseFloat(employee?.totalDaysWorked) /
            parseFloat(companySettings?.workingDays),
          useExcel,
          penTotal,
          retairefee,
          remainingRetairment,
          retaire,
          customHeaders,
          employeeType: theQueryParams.type || "All",
          userExtras,
          category: theQueryParams.category || "",
        };
      });

      return normalEmployees;
    } catch (error) {
      toast("Error calculating payroll", { type: "error" });
      setIsRuning(false);
      console.log(error);
    }
  };

  return {
    normalEmployees,
    searchItems,
    IsFetching,
    settingHeaders,
    returnParams,
    totalbenefit,
    totalallowance,
    totalbonus,
    totalGross,
    totalDeduct,
    totalNet,
    companySettings,
    deductionSettings,
    bonusSettings,
    allownaceSettings,
    benefitSettings,
    pendingRetirement,
    customHeaders,
    DeductionGroupName,
    BonusGroupName,
    AllowanceGroupName,
    BenefitGroupName,
    payrollSetting,
    payrollCycle,
    calculateEmployeePayroll,
    setNormalEmployees,
  };
};
